import React from "react";
import { useSbLayout } from "../../context/LayoutContext";


export default function FloatingToggle() {
  const { collapsed, toggleSidebar } = useSbLayout();

  return (
    <button className="sb-floating-toggle" onClick={toggleSidebar} type="button">
  <i className="fas fa-chevron-left" />
    </button>
  );
}
